import React, {PureComponent, useContext} from 'react';
import {withTranslation} from "react-i18next";
import {toast} from "react-toastify";
import Input from "../UI/Input/Input";
import specimenImg from "../../../../public/images/specimen.png";
import axios from "../../axios-defaults";
import Spinner from "../UI/Spinner";
import BodyForm from "../Documentations/InvoiceReview/ModalContent/Form";
import Alert from "../UI/Alerts/Alert";
import UserContext from '../../context/user-context';

class BudgetForm extends PureComponent {

	static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
			accountExist: false,
            loading: false,
            loadingForm: true,
            editing: false,
            formIsValid: false,
            budgetForm: {
				paymenttype: {
					elementType: 'radio',
					elementConfigs: {
						type: 'radio',
						placeholder: '',
						name: 'paymenttype',
						autoComplete: '',
						id: 'paymenttype',
						options: [
							{
								value: 'debit',
								innerHtml: 'budget.form.paymenttype.debit',
							},
							{
								value: 'equal',
								innerHtml: 'budget.form.paymenttype.equal'
							}]
					},
					label: "budget.form.paymenttype.label",
					validationRules: {
						required: true
					},
					value: 'debit',
					valid: true,
					touched: false,
					errorMessages: {
						required: "errors.fieldrequired"
					},
					errorMessage: "errors.fieldrequired",
				},
                fullname: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'fullname',
                        autoComplete: 'fullname',
                        id: 'txt_fullname',
                    },
                    label: "budget.form.fullname",
                    value: '',
                    validationRules: {
                        required: true,
                    },

                    valid: true,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
                telephone: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'telephone',
                        autoComplete: 'telephone',
                        id: 'txt_telephone',
                    },
                    label: "budget.form.telephone",
                    value: '',
                    validationRules: {
                        required: true,
                        matchRegex:"^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$"
                    },
                    valid: false,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
                address: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'address',
                        autoComplete: 'address',
                        id: 'txt_address',
                    },
                    label: "budget.form.address",
                    value: '',
                    validationRules: {
                        required: true,
                    },
                    valid: true,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
                postalcode: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'postalcode',
                        autoComplete: 'postalcode',
                        id: 'txt_postalcode',
                    },
                    label: "budget.form.postal_code",
                    value: '',
                    validationRules: {
                        required: true,
                        matchRegex:"^[A-Za-z]\\d[A-Za-z][ -]?\\d[A-Za-z]\\d$"
                    },
                    valid: true,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
                bank: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'bank',
                        autoComplete: 'bank',
                        id: 'txt_bank',
                    },
                    label: "budget.form.bank",
                    value: '',
                    validationRules: {
                        required: true,
                    },
                    valid: false,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
                notransit: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'notransit',
                        autoComplete: 'notransit',
                        id: 'txt_notransit',
                        maxLength: '5',
                    },
                    label: "budget.form.no_transit",
                    value: '',
                    validationRules: {
                        required: true,
                        matchRegex:"^\\d{5}$"
                    },
                    valid: false,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
                noinstitution: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'noinstitution',
                        autoComplete: 'noinstitution',
                        id: 'txt_noinstitution',
                        maxLength: '3',
                    },
                    label: "budget.form.no_institution",
                    value: '',
                    validationRules: {
                        required: true,
                        matchRegex:"^\\d{3}$"
                    },
                    valid: false,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
                noaccount: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'noaccount',
                        autoComplete: 'noaccount',
                        id: 'txt_noaccount',
                        maxLength: '7',
                    },
                    label: "budget.form.no_account",
                    value: '',
                    validationRules: {
                        required: true,
                        matchRegex:"^\\d{7}$"
                    },
                    valid: false,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired",
                },
				dpa: {
					elementType: 'input',
					elementConfigs: {
						type: 'hidden',
						placeholder: '',
						name: 'dpa',
						autoComplete: 'dpa',
						id: 'txt_dpa',
					},
					value: 'COM',
					valid: true,
					visible: false,
					touched: false,
				}
            }
        }
    }

	getAccountExist = () => {
		this.setState({loadingForm:true});

		axios.post(`/dataverse/account/exists`)
			.then(response => {
				if (response.data === 1) {
					this.setState({accountExist: true})
					this.setState({loadingForm:false});
				} else {
					this.setState({accountExist: false})
					this.setState({loadingForm:false});
				}
			}).catch(error => {
				console.log('[Account.js] : BudgetForm ajax error in getAccountExist()',error.message);
			});
	}

    submitBudgetPlanHandle = (e) => {
        e.preventDefault();
		this.validateForm();

        if(!this.state.formIsValid){
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t('budget.form.invalid_form')}
                </div>
            );
            return false;
        }

        this.setState({loading:true});

        const {paymenttype, fullname, telephone, address, postalcode, bank, notransit, noinstitution, noaccount, dpa} = this.state.budgetForm;

		// Store the paymenttype value in local storage
		if (this.props.onSubmit) {
			localStorage.setItem('paymentType', paymenttype.value);
			localStorage.setItem('hasPreAuthorizedAccount', this.context.user.account.hasPreAuthorizedAccount);
		}


		axios.post('/docusign/sign',
            {
                payment_type: paymenttype.value,
                full_name: fullname.value,
                phone_number: telephone.value,
                address: address.value,
                postal_code: postalcode.value,
                bank: bank.value,
                branch: noinstitution.value,
                transit: notransit.value,
                account_number: noaccount.value,
				dpa: dpa.value
            })
            .then(response => {
                if (response.data.succeeded) {
                        window.open(response.data.data.url, '_self');
                }
                else{
                    let errorMessages = [];
                    {Object.keys(response.data.errors).forEach(function (key) {
                        errorMessages.push(response.data.errors[key][0]);
                    })}

                    toast.error(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{errorMessages.join('\n\r')}
                            </div>
                        </div>
                    );
                }
            }).catch(error => {
                console.log('[BudgetForm.js] : Post docusign error in submitBudgetPlanHandle()', error.message);
                this.setState({loading: false});
            }
        );
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedBudgetForm = {...this.state.budgetForm};
        const updatedFormElement = {...updatedBudgetForm[inputIdentifier]}

        updatedFormElement.value = event.target.value;
        const validationResult = this.checkValidity(updatedFormElement, updatedFormElement.value, updatedFormElement.validationRules);
        updatedFormElement.valid = validationResult.valid
        if (validationResult.valid)
            updatedFormElement.errorMessage = "";
        else
            updatedFormElement.errorMessage = validationResult.errorMessages.join(', ');

        updatedFormElement.touched = true;

        updatedBudgetForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedBudgetForm) {
            let inputValidity = updatedBudgetForm[inputIdentifier].valid
            formIsValid = inputValidity && formIsValid;
        }

        this.setState({
            budgetForm: updatedBudgetForm,
            formIsValid: formIsValid
        });
    }


    validateForm = () => {
        const updatedBudgetForm = {...this.state.budgetForm};
        let formIsValid = true;
        for(let inputIdentifier in updatedBudgetForm){
            if (updatedBudgetForm[inputIdentifier].elementConfigs.type == 'hidden')
                continue;

            const validationResult = this.checkValidity(updatedBudgetForm[inputIdentifier], updatedBudgetForm[inputIdentifier].value, updatedBudgetForm[inputIdentifier].validationRules);

            if (!validationResult.valid){
                updatedBudgetForm[inputIdentifier].valid = false;
                updatedBudgetForm[inputIdentifier].touched = true;
                updatedBudgetForm[inputIdentifier].errorMessage = validationResult.errorMessages.join(', ')
            }

            formIsValid = formIsValid && updatedBudgetForm[inputIdentifier].valid;

        }

        this.setState({
            budgetForm: updatedBudgetForm,
            formIsValid: formIsValid
        });
    }

    checkValidity = (formElement,value,rules) => {
        let isValid = true;
        let errors = [];

        if(rules.required){
			const ruleValid = value !== null && value.trim() !== '';
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.required))
            isValid = ruleValid && isValid;
        }

        if(rules.minLength){
            const ruleValid = value.length >= rules.minLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.minLength))
            isValid = ruleValid && isValid;
        }

        if(rules.maxLength){
            const ruleValid = value.length >= rules.maxLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.maxLength))
            isValid = value.length <= rules.maxLength && isValid;
        }


        if(rules.matchRegex){
            const ruleValid = value !== null && value.match(rules.matchRegex) != null
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.matchRegex))
            isValid = ruleValid && isValid;
        }

        return {valid:isValid,errorMessages:errors};
    }

    async componentDidMount() {
        const user = await axios.get(`/user`);
        const account = await axios.get(`/accounts`)
        this.fillForm(user.data.data, account.data.data);
		this.getAccountExist();

		// Update the dpa value in the budgetForm state
		if (this.context && this.context.user.account.classification.code) {
			this.setState(prevState => ({
				budgetForm: {
					...prevState.budgetForm,
					dpa: {
						...prevState.budgetForm.dpa,
						value: this.context.user.account.classification.code, // Set the context value here
					},
				},
			}));
		}
	}

    fillForm = (user, account) => {
        let updatedBudgetForm = {...this.state.budgetForm};

        updatedBudgetForm.fullname.value = `${account.name}`;
		if(user.telephone && user.telephone !== ""){
			updatedBudgetForm.telephone.value = user.telephone;
			updatedBudgetForm.telephone.valid = true;
		}

        updatedBudgetForm.address.value = `${account.address.addressLine1}, ${account.address.city}, ${account.address.stateOrProvinceCode}`;
        updatedBudgetForm.postalcode.value = account.address.postalCode;

        this.setState({
            budgetForm: updatedBudgetForm,
        });
    };


    render() {
        const {
            loading,
            loadingForm,
			accountExist
        } = this.state;

        const formElements = [];
        for(let key in this.state.budgetForm){
            let configs = this.state.budgetForm[key];

			if (key === 'paymenttype' && this.context.user && this.context.user.account && this.context.user.account.classification && this.context.user.account.classification.code !== 'RES') {
				configs.elementConfigs.options = configs.elementConfigs.options.filter(
					option => option.value !== 'equal'
				);

			}


			formElements.push({
                id: key,
                configs: configs
            })
        }


        return (
			<div>
				{loadingForm ? (
						<div className="container flex flex-column justify-content-center align-items-center">
							<Spinner/>
						</div>
					) :
					<div>
				{accountExist ?
            		<div>
						<p><strong>{this.props.t("budget.title_form")}</strong></p>

						<form className="flex flex--direction-column form form--budget" onSubmit={() => { return false; }}>
							<div className="form__wrapper">

								<div className="form__inner">
									{formElements.slice(0, 1).map((element) => (
										<Input
											key={element.id}
											label={element.configs.label}
											innerHtml={element.configs.innerHtml}
											inputClasses={element.configs.elementConfigs.name}
											elementtype={element.configs.elementType}
											elementconfigs={element.configs.elementConfigs}
											value={element.configs.value === null ? '' : element.configs.value}
											valid={element.configs.valid}
											shouldValidate={element.configs.validationRules}
											touched={element.configs.touched}
											changed={(event) => this.inputChangedHandler(event, element.id)}
											errorMessage={element.configs.errorMessage}
										/>
									))}

									{formElements.slice(1, 5).map(element => (
										<Input key={element.id}
											   label={element.configs.label}
											   inputClasses={element.configs.elementConfigs.name}
											   elementtype={element.configs.elementType}
											   elementconfigs={element.configs.elementConfigs}
											   value={element.configs.value === null ? '' : element.configs.value}
											   valid={element.configs.valid}
											   shouldValidate={element.configs.validationRules}
											   touched={element.configs.touched}
											   changed={(event) => this.inputChangedHandler(event,element.id)}
											   errorMessage={element.configs.errorMessage}/>
									))}
								</div>

								<div className="form__inner">
									{formElements.slice(5, 10).map(element => (
										<Input key={element.id}
											   label={element.configs.label}
											   inputClasses={element.configs.elementConfigs.name}
											   elementtype={element.configs.elementType}
											   elementconfigs={element.configs.elementConfigs}
											   value={element.configs.value}
											   valid={element.configs.valid}
											   shouldValidate={element.configs.validationRules}
											   touched={element.configs.touched}
											   changed={(event) => this.inputChangedHandler(event,element.id)}
											   errorMessage={element.configs.errorMessage}/>
									))}
									<img
										className="form__img"
										src={specimenImg}
										alt={this.props.t('budget.form.check_specimen_alt')}
										title={this.props.t('budget.form.check_specimen_alt')}
									/>
								</div>
							</div>

							<div className="form__action">
							{loading ? (
								<div className="container flex flex-column justify-content-center align-items-center">
									<Spinner/>
								</div>
								) :
								<button type="submit"
										className="btn btn--outline"
										onClick={this.submitBudgetPlanHandle}>
									{this.props.t("budget.form.submit")}
								</button>
							}
							</div>
						</form>
            	</div>:
					<div className="modal-body p-0">
						<div className="message message--danger">
							<div className="message__icon">
								<i className="fas fa-exclamation-triangle" aria-hidden="true"></i>
							</div>
							<div className="message__content">
								{this.props.t('misc.account_not_found.line.one')} <br/>
								{this.props.t('misc.account_not_found.line.two')} <br/><br/>
								{this.props.t('misc.account_not_found.line.three')} <br/>
							</div>
						</div>
					</div>
				}
				</div>
				}
			</div>
        );
    }
}

export default withTranslation()(BudgetForm);


